import type { Blocker, History, Transition } from 'history';
import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

// workaround for React Router v6 which has no such hook. Works with react-router-dom versions not higher than 6.3.0
export function useBlocker(blocker: Blocker): void {
  const history = useContext(NavigationContext).navigator as unknown as History;
  useEffect(() => {
    let unblock: () => void = () => {};
    const beforeUnloadListener = (): void => unblock();
    // see https://github.com/remix-run/history/issues/921#issuecomment-1029055351
    window.addEventListener('beforeunload', beforeUnloadListener);
    unblock = history.block((tx: Transition) => {
      blocker({
        ...tx,
        retry: () => {
          unblock();
          tx.retry();
        },
      });
    });
    return () => {
      unblock();
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, [history, blocker]);
}
